import { Alert, AlertColor, Snackbar } from "@mui/material";

type SnackbarProps = {
    message: string,
    setMessage: (s: string) => void,
    severity: AlertColor,
}

const FormSnackbar = ({ message, setMessage, severity }: SnackbarProps) => {
    const handleClose = () => {
        setMessage("");
    }
    
    return (
        <Snackbar
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            open={message !== ""}
            autoHideDuration={10000}
            onClose={handleClose}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {message}
            </Alert>
        </Snackbar>
    )
}

export default FormSnackbar;
